import constants from "../constants";

const initialState = {
  isAuthorized: false,
  userRole: "" || localStorage.getItem("role"),
  userToken: "" || localStorage.getItem("token"),
  isEmailSent: false,
  isVerified: false,
  isPasswordUpdated: false,
  userDetails: null,
  passwordError: false,
  emailError: false,
  allOfferComments: [],
  jobDetail: {},
  allNotifications: [],
  totalNotifications: 0,
  uploadedFiles: [],
  profileImageUrl: null,
};

const userStore = (state = initialState, action) => {
  switch (action.type) {
    case constants.reducerActions.login:
      return {
        ...state,
        userToken: action.userToken,
        userRole: action.userRole,
      };
    case constants.reducerActions.mailSent:
      return {
        ...state,
        isEmailSent: action.isSent,
      };
    case constants.reducerActions.verifyEmail:
      return {
        ...state,
        isVerified: action.isVerified,
      };
    case constants.reducerActions.changePassword:
      return {
        ...state,
        isPasswordUpdated: action.isPasswordUpdated,
      };
    case constants.reducerActions.userDetails:
      return {
        ...state,
        userDetails: action.userDetails || null,
        profileImageUrl: action.userDetails.profileImageUrl || null,
      };
    case constants.consultantActions.allComments:
      return {
        ...state,
        allOfferComments: [...action.allComments],
      };
    case constants.reducerActions.progress:
      return {
        ...state,
        jobDetail: action.jobDetail,
      };
    case constants.reducerActions.notifications:
      return {
        ...state,
        allNotifications: [...action.allNotifications],
        totalNotifications: action.totalNotifications,
      };
    case constants.clientActions.uploadFile:
      return {
        ...state,
        uploadedFiles: [...state.uploadedFiles, action.fileId],
      };
    case constants.reducerActions.imageUrl:
      return {
        ...state,
        profileImageUrl: action.imageUrl,
      };
    default:
      return {
        ...state,
      };
  }
};

export default userStore;
